<template>
  <div class="login">
    <div class="image-box">
      <img class="bgImg" src="/static/images/bgImg.png">
    </div>

    <div class='content'>
      <!-- 头部 -->
      <div class="binding-top-container">
        <div class="binding-top">
          <img src="/static/images/logo.svg" style="width: 191px; height: 93.5px;"></img>
        </div>
      </div>

      <div class="body">
        <div class="main-info">
          <div class="input">
            <input class="phone" placeholder="请输入手机号" maxlength="11" v-model="phone"></input>
          </div>
          <div class="input" style="margin-top: 30px">
            <input class="code" placeholder="请输入验证码" v-model="code"></input>
<!--            <div class="code-btn">-->
              <p v-if="time == 0" class="code-btn" @click="getSMSCode">获取验证码</p>
              <p v-else class="code-btn">{{ time }}s</p>
<!--            </div>-->
          </div>
          <!-- 按钮 -->
          <div class="new-button">
            <div class='function-btn btn' @click="miLogin()">登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer" v-show="hideshow">
      登录即代表同意HiPC的
      <a href="https://hipc.cn/xieyi.html">《用户协议》</a>
      和
      <a href="https://hipc.cn/privacy.html">《隐私政策》</a>
    </div>
  </div>
</template>

<script>
import {getCode,login} from '@/api/login'
import store from '../../store'
export default {
  name: 'MiLogin',
  data(){
    return {
      docmHeight: window.innerHeight,  //默认屏幕高度
      showHeight: window.innerHeight,   //实时屏幕高度
      hideshow:true,  //显示或者隐藏footer
      phone: '',
      code: '',
      key:'',
      time: 0
    }
  },
  mounted(){
    // window.onresize监听页面高度的变化
    window.onresize = ()=>{
      return(()=>{
        this.showHeight = window.innerHeight;
      })()
    };
  },
  //监听
  watch:{
    showHeight: function(newValue) {
      if(this.docmHeight > newValue){
        this.hideshow = false
      }else{
        this.hideshow = true
      }
    }
  },
  methods: {
    getSMSCode(){
      let opt_data = {
        phone: this.phone
      }
      // const params = new URLSearchParams();
      // params.append('phone',this.phone)
      getCode(opt_data).then( res => {
        if (res.code == 100){
          this.$message({
            message: '认证码发送成功',
            type: 'success'
          });
          this.key = res.data.key
          this.time = 60;
          this.timer()
        }else {
          this.$message.error(res.message)
        }
      })
    },
    timer() {
      if (this.time > 0) {
        this.disabled=true;
        this.time--;
        setTimeout(this.timer, 1000);
      }
    },
    miLogin(){
      const params = new URLSearchParams();
      params.append('phone',this.phone)
      params.append('code',this.code)
      params.append('key',this.key)
      login(params).then( res => {
        // console.log(res)
        if (res.code == 100){
          this.$message.success(res.message)
          this.$store.commit('setToken', res.data.token);
        }else {
          this.$message.error(res.message)
        }
      })
    },
  }
}
</script>

<style scoped>
.image-box {
  width: 100%;
}

.image-box .bgImg {
  width: 100%;
  display: block;
}

.content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}

.binding-top-container div {
  text-align: center;
  margin-bottom: 10px;
  color: #fff;
}

.binding-top-container .binding-top {
  height: 94px;
  width: 191px;
  margin: 35px auto 30px;
}

.binding-top img {
  width: 100%;
  height: 100%;
}

.body {
  padding: 10px 20px 30px;
}

.body .main-info {
  width: 100%;
  padding: 30px 20px 90px;
  margin-bottom: 10px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  /* box-shadow:0px 2px 10px 0px rgba(184,192,204,0.4); */
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  position: relative;
}

.input {
  border-bottom: 1px solid #eee;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-bottom: 10px;
}
.input .phone{
  width: 100%;
  border:none;
  outline: none;
  font-size: 16px;
}
.input .code{
  width: 100%;
  border:none;
  outline: none;
  font-size: 16px;

}
.input .code-btn{
  width: 100px;
  text-align: center;
  font-size: 14px;
  color: #409EFF;
  /*position: relative;*/
}
.input .code-btn p{
  position: absolute;
  bottom: 2px;
  right: 0;
}
.btn-box{
  text-align: center;
  margin-top: 40px;
}

/* 按钮 */
.new-button {
  /*padding: 20px 10px 0;*/
  margin-top: 40px;
}

.function-btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #3385ff;
  color: #fff;
  font-size: 16px;
  text-align: center;
  margin-top: 10px;
  border-radius: 50px;
}

.content .btn {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.login-footer{
  width: 100%;
  text-align: center;
  position: fixed;
  bottom: 25px;
  font-size: 12px;
  color: #b2b2b2;
  z-index: 11;
}
.login-footer a{
  text-decoration:none;
  color: #000;
}

</style>



// WEBPACK FOOTER //
// src/view/hipc/MiLogin.vue